import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {MdAvailability} from '../models/mdAvailability';

@Injectable()
export class MdAvailabilityService {

  constructor(private httpClient: HttpClient) {
  }

  getMdAvailabilities(): Observable<MdAvailability[]> {
    return this.httpClient.get<MdAvailability[]>(environment.baseUrlWs + '/api/md-availability');
  }

  changePublicDescription(id, publicDescription: string) {
    return this.httpClient.put<MdAvailability>(environment.baseUrlWs + '/api/md-availability/' + id, {'publicDescription': publicDescription});
  }

  getMdAvailabilityIncludingUat(): Observable<MdAvailability[]> {
    return this.httpClient.get<MdAvailability[]>(environment.baseUrlWs + '/api/md-availability-uat');
  }

  getMdAvailabilitiesForMap(): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/md-availability-map');
  }
}
